export default __webpack_public_path__ + "static/media/pic2.07e80607.jpg";